<template>
	<div class="admin">
		<div>
			<div @click='adminMore=!adminMore'>
				<i class="iconfont icon-user_01" style="font-size: 20px;"></i>
				<span :title='USERNAME'>{{USERNAME}}</span>
				<i class="iconfont icon-arrow_up admin_arrow_up" 
				:style="adminMore?'transform:rotate(0deg)':'transform:rotate(180deg)'"></i>
			</div>
			<div v-if='adminMore' class="adminMore">
				<div class="admin_item" @click='adminMore=false;goRouter();'>
					<i class="iconfont icon-set"></i>
					<span>个人设置</span>
				</div>
				<div class="admin_item" @click='adminMore=false;loginOut()'>
					<i class="iconfont icon-turn_off"></i>
					<span>退出</span>
				</div>
			</div>
		</div>

	</div>
</template>

<script scoped>
	import {mapGetters} from 'vuex'
    import pageRouter from "@/utils/pageRouter"
	export default {
		name: 'admin',
		components: {
		},
		inject: ['reload'],
		data() {
			return {
				adminMore: 0,				
                goRouterTab: {
                    code: "personSet",
                    name: "个人设置",
                    root: "singlePages"
                },
			}
		},
		computed: {
			...mapGetters('user', {
				USERID: 'userId',
				USERNAME: 'userName'
			})
		},
		mounted() {
			this.addRouter()
		},
		methods: {
            // 添加
            addRouter() {
                pageRouter(this, "personSet",
                 "singlePages/personSet/index")
                .catch(res => {
                    this.$message.error('个人设置路由添加失败！')
                })
            },
            // 去添加
            goRouter() {
                this.$store.dispatch("tabs/switchTab_single", this.goRouterTab)
            },
			loginOut () {
				this.$confirm('确认退出管理系统吗？', '温馨提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消'
		        }).then(() => {
      				this.$store.dispatch('user/loginOut')
					.then(res => {
						this.$store.dispatch('tabs/removeAllTabs')
						this.reload()
					}).catch(res => {
						this.$message.error = '退出失败'
					})
		        })
			}
		}
	};
</script>

<style type="text/less" lang="less" scoped>
.admin{
	position: relative;
	z-index: 99;
	max-width: 200px;
	height: 100%;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: right;
	.fa-user-o{
		font-size: 20px;
	}
	span{
		margin: 0 5px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: inline-block;
		max-width: 150px;
		white-space: nowrap;
		vertical-align: middle;
	}
	i{
		color: #A2A6AD;
		vertical-align: middle;
	}
	.admin_arrow_up{
		display: inline-block;
		transition: all 0.2s;
	}
}
.adminMore{
	position: absolute;
	right: 0;
	top: 80%;
	width: max-content;
	text-align: left;
	padding: 7px 12px 18px;
	background: #fff;
	box-shadow: 0 2px 12px 0 rgba(0,0,0,.4);
	border-radius: 2px;
	.admin_item{
		margin-top: 22px;
		span{
			color: #A2A6AD;
			font-size: 14px;
			&:hover{
				color: #D0021B;
			};
		}
		i{
			color: #4A4A4A;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Admin.vue